module.exports = __webpack_public_path__ + "assets/img/title-2981916e.png";